import React from "react";
import ReactDOM from "react-dom";
import Router from "react-router";
import configureStore from "../common/configureStore";
import createBrowserHistory from "history/lib/createBrowserHistory";
import createRoutes from "./createRoutes";
import { IntlProvider } from "react-intl";
import { Provider } from "react-redux";
import configureReporting from "../common/configureReporting";
import config from "../config";
import reactTapEvent from "react-tap-event-plugin";
import { getAuthCookie } from "../common/lib/auth";
import Auth from "../common/users/auth";
import cookie from "cookie-dough";

const auth = getAuthCookie(cookie);

// Enabling ES7 `async/await` in browser:
//if (process.env.IS_BROWSER) require("regenerator/runtime");

reactTapEvent();

const app = document.getElementById("root");

const initialState = {
  config,
  users: { viewer: auth }
};

const reportingMiddleware = configureReporting({
  appVersion: initialState.config.appVersion,
  sentryUrl: initialState.config.sentryUrl,
  unhandledRejection: fn => window.addEventListener("unhandledrejection", fn)
});

const store = configureStore({
  initialState,
  platformMiddleware: [reportingMiddleware]
});

const routes = createRoutes(store.getState);

ReactDOM.render(
  <Provider store={store}>
    <IntlProvider>
      <Router history={createBrowserHistory()}>{routes}</Router>
    </IntlProvider>
  </Provider>,
  app,
  () => {}
);



// WEBPACK FOOTER //
// ./src/browser/main.js